import { createSlice } from '@reduxjs/toolkit'

import { initialState } from './constants'
import { getCurrenciesThunk } from './thunks'

const currenciesSlice = createSlice({
  name: 'currencies',
  initialState,
  reducers: {
    setCurrenciesReady: (state) => {
      state.ready = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCurrenciesThunk.fulfilled, (state, action) => {
      state.currencies = action.payload
      state.ready = true
    })
  },
})

export const { setCurrenciesReady } = currenciesSlice.actions
export default currenciesSlice.reducer
